// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useTenantStore } from "@/providers/TenantContextProvider";
import { useContext } from "react";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
export function useUsersPermissions(electionEventId) {
    var tenantId = useTenantStore()[0];
    var authContext = useContext(AuthContext);
    /**
     * Permissions
     */
    var canImportUsers = authContext.isAuthorized(true, tenantId, IPermissions.USER_IMPORT);
    var canWritePermissionLabels = authContext.isAuthorized(true, tenantId, IPermissions.PERMISSION_LABEL_WRITE);
    var canExportVoters = authContext.isAuthorized(true, tenantId, IPermissions.VOTER_EXPORT);
    var canCreateVoters = authContext.isAuthorized(true, tenantId, electionEventId ? IPermissions.VOTER_CREATE : IPermissions.USER_CREATE);
    var canEditVoters = authContext.isAuthorized(true, tenantId, electionEventId ? IPermissions.VOTER_WRITE : IPermissions.USER_WRITE);
    var canReadVoterSecretAttributes = authContext.isAuthorized(true, tenantId, IPermissions.VOTER_SECRET_ATTRIBUTE_READ);
    var canWriteVoterSecretAttributes = authContext.isAuthorized(true, tenantId, IPermissions.VOTER_SECRET_ATTRIBUTE_WRITE);
    var canEditVotersWhoVoted = authContext.isAuthorized(true, tenantId, IPermissions.VOTER_VOTED_EDIT);
    var canEditVotersEmailTlf = Boolean(electionEventId) &&
        authContext.isAuthorized(true, tenantId, IPermissions.VOTER_EMAIL_TLF_EDIT);
    var canDeleteVoters = authContext.isAuthorized(true, tenantId, electionEventId ? IPermissions.VOTER_DELETE : IPermissions.USER_WRITE);
    var canImportVoters = authContext.isAuthorized(true, tenantId, IPermissions.VOTER_IMPORT);
    var canManuallyVerify = authContext.isAuthorized(true, tenantId, IPermissions.VOTER_MANUALLY_VERIFY);
    var canChangePassword = authContext.isAuthorized(true, tenantId, IPermissions.VOTER_CHANGE_PASSWORD);
    var canGenerateVoterInformationLetter = authContext.isAuthorized(true, tenantId, IPermissions.VOTER_INFORMATION_LETTER) &&
        authContext.isAuthorized(true, tenantId, IPermissions.DOCUMENT_PASSWORD_READ);
    var showVotersColumns = authContext.isAuthorized(true, tenantId, IPermissions.EE_VOTERS_COLUMNS);
    var showVotersFilters = authContext.isAuthorized(true, tenantId, IPermissions.EE_VOTERS_FILTERS);
    var showVotersLogs = authContext.isAuthorized(true, tenantId, IPermissions.EE_VOTERS_LOGS);
    var canSendTemplates = authContext.isAuthorized(true, tenantId, IPermissions.NOTIFICATION_SEND);
    var showVoterListSync = authContext.isAuthorized(true, tenantId, IPermissions.ELECTION_EVENT_VOTER_LIST_SYNC);
    /**
     * Permissions
     */
    return {
        canImportUsers: canImportUsers,
        canWritePermissionLabels: canWritePermissionLabels,
        canCreateVoters: canCreateVoters,
        canEditVoters: canEditVoters,
        canReadVoterSecretAttributes: canReadVoterSecretAttributes,
        canWriteVoterSecretAttributes: canWriteVoterSecretAttributes,
        canEditVotersWhoVoted: canEditVotersWhoVoted,
        canEditVotersEmailTlf: canEditVotersEmailTlf,
        canDeleteVoters: canDeleteVoters,
        canImportVoters: canImportVoters,
        canExportVoters: canExportVoters,
        canManuallyVerify: canManuallyVerify,
        canChangePassword: canChangePassword,
        canGenerateVoterInformationLetter: canGenerateVoterInformationLetter,
        showVotersColumns: showVotersColumns,
        showVotersFilters: showVotersFilters,
        showVotersLogs: showVotersLogs,
        canSendTemplates: canSendTemplates,
        showVoterListSync: showVoterListSync,
    };
}
